import React from "react";
import { Tooltip } from "antd";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import { useSearch } from "../../../../../contexts/SearchContext";
import "./SearchParamsLockButton.css";

const SearchParamsLockButton = ({ className = "" }) => {
  const {
    searchParamsLocked,
    toggleSearchParamsLock,
    canLockSearchParams,
  } = useSearch();

  const canLock = canLockSearchParams();
  const isLocked = Boolean(searchParamsLocked);

  const tooltipTitle = isLocked
    ? "שחרר נעילה — מעבר קטגוריה יאפס יעד, תאריכים והרכב"
    : canLock
      ? "נעל יעד, תאריכים והרכב — יישמרו במעבר בין קטגוריות"
      : "יש לבחור יעד, תאריכים והרכב לפני הנעילה";

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <button
        type="button"
        className={[
          "search-params-lock-btn",
          isLocked ? "search-params-lock-btn--locked" : "",
          !canLock && !isLocked ? "search-params-lock-btn--disabled" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => {
          if (!isLocked && !canLock) return;
          toggleSearchParamsLock();
        }}
        disabled={!isLocked && !canLock}
        aria-pressed={isLocked}
        aria-label={isLocked ? "שחרר נעילת פרמטרי חיפוש" : "נעל פרמטרי חיפוש"}
      >
        {isLocked ? (
          <LockOutlined className="search-params-lock-btn__icon" aria-hidden />
        ) : (
          <UnlockOutlined className="search-params-lock-btn__icon" aria-hidden />
        )}
      </button>
    </Tooltip>
  );
};

export default SearchParamsLockButton;
